import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import React from 'react';

var ColumnGroup = function (_React$Component) {
  _inherits(ColumnGroup, _React$Component);

  function ColumnGroup() {
    _classCallCheck(this, ColumnGroup);

    return _possibleConstructorReturn(this, (ColumnGroup.__proto__ || Object.getPrototypeOf(ColumnGroup)).apply(this, arguments));
  }

  return ColumnGroup;
}(React.Component);

export default ColumnGroup;

ColumnGroup.__ANT_TABLE_COLUMN_GROUP = true;


//////////////////
// WEBPACK FOOTER
// ./~/antd/es/table/ColumnGroup.js
// module id = 760
// module chunks = 0